// Routes
export const HOME_ROUTE = "/:lng/";
export const LOGIN_ROUTE = "/:lng/login";
export const REGISTER_ROUTE = "/:lng/register";
export const RESET_PASSWORD_ROUTE = "/:lng/reset-password/:code";
export const CHANGE_PASSWORD = "/:lng/login-edit";
export const ROOM_INFO_ROUTE = "/:lng/room-info";
export const ROOM_INFO_ROUTE_ID = "/:lng/room-info/:id";
export const STUDENT_PROFILE_EDIT_FIRST_ROUTE = "/:lng/student-edit-first";

export const STUDENT_PROFILE_EDIT_ROUTE = "/:lng/student-edit";
export const STUDENT_PROFILE_VIEW_ROUTE = "/:lng/student";

export const STUDENT_ROUTE_ID = "/:lng/student/:id";
export const STUDENT_ROOMS_ROUTE = "/:lng/rooms";
export const STUDENT_MATCHES_ROUTE = "/:lng/matches";
export const STUDENT_CHATS_ROUTE = "/:lng/chats";
export const STUDENT_CHATS_ROUTE_ID = "/:lng/chats/:id";
export const STUDENT_WIZARD_ROUTE = "/:lng/student-wizard";
export const STUDENT_WIZARD_FINISHED_ROUTE = "/:lng/student-wizard/finished";
export const STUDENT_TIPS_ROUTE = "/:lng/faq#registration";

export const HOST_PROFILE_EDIT_FIRST_ROUTE = "/:lng/host-edit-first";
export const HOST_PROFILE_EDIT_ROUTE = "/:lng/host-edit";
export const HOST_PROFILE_VIEW_ROUTE = "/:lng/host";
export const HOST_ROOMS_ROUTE = "/:lng/rooms";
export const HOST_HOUSE_WIZARD_ROUTE =
  "/:lng/house-wizard/:houseId/:wizardType";
export const HOST_ROOM_REPUBLISH_ROUTE = "/:lng/room-republish/:id";
export const HOST_CHATS_ROUTE = "/:lng/chats";
export const HOST_CHATS_ROUTE_ID = "/:lng/chats/:id";
export const HOST_TENANTS_ROUTE = "/:lng/tenants";
export const HOST_TIPS_ROUTE = "/:lng/faq";
export const HOST_WIZARD_ROUTE = "/:lng/host-wizard";
// export const HOST_WIZARD_PHOTOS_ROUTE = "/:lng/host-wizard-photos";
export const HOST_HOUSE_EDIT_ROUTE = "/:lng/house-edit/:id";
export const HOST_PLAN_INTAKE_ROUTE = "/:lng/plan-intake";

export const FIND_ROOM_ROUTE = "/:lng/students";
export const BECOME_HOST_ROUTE = "/:lng/hospita";
export const TEAM_ROUTE = "/:lng/team";
export const PRESS_ROUTE = "/:lng/press";
export const PARTNERS_ROUTE = "/:lng/partners";
export const MISSION_ROUTE = "/:lng/mission";
export const BLOG_ROUTE = "/:lng/blog";
export const VACANCIES_ROUTE = "/:lng/vacancies";
export const FAQ_ROUTE = "/:lng/faq";
export const CONTACT_ROUTE = "/:lng/contact";
export const PRIVACY_ROUTE = "/:lng/privacy";
export const COOKIES_ROUTE = "/:lng/cookies";
export const CONTACT_DETAILS_ROUTE = "/:lng/contactdetails";

// SERVER API PATH
export const API_USERS = "users/api/";
export const API_HOUSES = "houses/api/";
export const API_MATCHES = "matches/api/";
export const API_CHATS = "chats/api/";

// Empty string for validator
export const EMPTY = "empty";

export enum WEEK {
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
}

export enum MONTHS {
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
}

// Using Languages
export const LANGUAGES = ["GB", "NL"];

// Host House
export const TYPE_ROOM = ["room", "studio", "entire_house"] as const;

export const HOUSE_STATUS = [
  "DRAFT",
  "PUBLISHED",
  "RENTED",
  "ARCHIVED",
  "PENDING_PUBLISHED",
  "PENDING_DRAFT"
] as const;

//  Match service
export enum MatchStatusEnum {
  LIKED = 1,
  CHATTED,
  INVITED,
  ACCEPTED,
  PENDING,
  ACTIVE,
  ARCHIVED
}

export const SHARED_USE = [
  "toilet",
  "bathroom",
  "kitchen",
  "livingroom",
  "washing machine",
  "terrace",
  "balcony",
  "garden"
] as const;

export const PRIVATE_USE = [
  "toilet",
  "bathroom",
  "kitchen",
  "furnished room",
  "sink",
  "internet",
  "double bed",
  "balcony",
  "tv"
] as const;

export const HOUSE_DEPUBLISH_REASONS = [
  "found_tenant_via_hospi",
  "found_tenant_via_different_platform",
  "found_tenant_via_own_network",
  "enough_responses",
  "postpone_rental",
  "decide_not_rent_out",
  "experience_tech_issues",
  "other"
] as const;

export const NO_END_DATE = new Date("2101-01-01T00:00:00");

export const FETCHED_CHATS_BATCH_AMOUNT = 50;
